//import Utils
import * as cartUtils from '../Utils/CartUtils';

// export const loadCart = () => {
//     return (dispatch, getState, getFirebase) => {
//         const {login, uid} = getState().user;
//         if(login) {
//             dispatch(loadCartDB(uid));
//         } else {
//             dispatch(loadCartLocal());
//         }
//     }
// }

export const loadCartLocal = () => {
    return (dispatch, getState, getFirebase) => {
        try {
            const serializedCart = localStorage.getItem('cart');
            console.log('load Cart local' ,serializedCart);
            if (serializedCart === null) {
                dispatch(loadCartFail());
                return;
            }
            dispatch(loadCartSuccess(JSON.parse(serializedCart)))
        } catch (e) {
            dispatch(loadCartFail());
        }
    }
}

export const loadLastOrderAsCart = (uid) => {
    return (dispatch, getState, getFirebase) => {

            console.log('haganfan');

        if(!uid) {
            return;
        }
        const firebase = getFirebase();
        const orders = getState().user.orders;


        if (orders) {
            const lastOrder = orders[orders.length - 1];
            const orderRef = firebase.ref().child(`orders/${lastOrder}`);


            orderRef.once('value', (snapshot) => {
                const snapshotData = snapshot.val();
                if(snapshotData) {
                    const { cart } = snapshotData;
                    let carts = [];
                    for (var key in cart) {
                        carts.push(cart[key]);
                    }
                    const cartRef = firebase.ref().child(`cart/${uid}`);
                    cartRef.set(cart)
                        .then(() => {
                            dispatch(loadCartSuccess(carts))
                        })
                        .catch(() => {

                        })
                }
            })
        } else {
            dispatch(loadCartSuccess([]));
        }
    }
}

export const loadCartDB = (uid) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const cartRef = firebase.ref().child(`cart/${uid}`);
        cartRef.on('value', (snapshot) => {
            let carts=[];
            snapshot.forEach(c => {
                carts.push(c.val());
            })

            if((carts == null) || (carts !== null && carts.length === 0)) {
                dispatch(loadLastOrderAsCart(uid));
            }
            else {
                dispatch(loadCartSuccess(carts))
            }
        })
    }
}

export const loadCartSuccess = (cart) => {
    return {
        type : 'LOAD_CART_SUCCESS',
        payload : {
            cart
        }
    }
}
export const loadCartFail = () => {
    return {
        type : 'LOAD_CART_FAIL'
    }
}

export const addToCart = (data) => {

    const {id, quantity, typeIndex} = data;

    return (dispatch, getState, getFirebase) => {
        const { login, uid } = getState().user;
        if(login) {
            dispatch(addToCartDB(uid, id, typeIndex, quantity));
        }else{
            dispatch(addToCartLocal(id, typeIndex, quantity));
        }
    }
}
export const addToCartLocal = (id, typeIndex, quantity) => { 
   return {
        type : 'ADD_TO_CART_LOCAL',
        payload : {
            id,
            typeIndex,
            quantity
        }
    }
}

export const addToCartDB = (userID, productID, typeIndex, quantity)=> {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const cartRef  = firebase.ref().child(`cart/${userID}`);

        cartRef.once('value', (snapshot) => {
            let cart = [];
            snapshot.forEach((item) => {
                cart.push(item.val());
            })

            cart = cartUtils.addProduct(cart, productID, typeIndex, quantity);
            console.log(cart);

            cartRef.set(cart)
                .then( ()=> {
                })
                .catch( (e)=> {
                })
        })
    }
}
export const addToCartSuccess = () => {
    return {
        type : 'ADD_TO_CART_SUCCESS'
    }
}
export const addToCartFail = ()=> {
    return {
        type : 'ADD_TO_CART_FAIL'
    }
}

export const removeFromCart = (id, typeIndex) => {
    return (dispatch, getState, getFirebase) => {
        const { login, uid } = getState().user;
        if(login) {
            dispatch(removeFromCartDB(uid, id, typeIndex));
        } else {
            dispatch(removeFromCartLocal(id, typeIndex))
        }
    }
}
export const removeFromCartDB = (userID, productID, typeIndex) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const cartRef = firebase.ref().child(`cart/${userID}`);
        cartRef.once('value', (snapshot) => {
            let cart = [];
            snapshot.forEach((item) => {
                cart.push(item.val());
            })
            cart = cartUtils.removeProduct(cart, productID, typeIndex);
            console.log(cart);
            cartRef.set(cart)
                .then( ()=> {
                    console.log('reomved');
                })
                .catch( (e)=> {
                })
        })
    }
}
export const removeFromCartLocal = (id, typeIndex) => {
    return {
        type : 'REMOVE_FROM_CART_LOCAL',
        payload : {
            id,
            typeIndex
        }
    }
}


export const sendOrder = (datas, funcs) => {
    return (dispatch, getState, getFirebase) => {
        const { uid } = getState().user;
        const firebase = getFirebase();

        const current = new Date();

        const padZero = (number) => {
            const s = number.toString();
            if(s.length === 1) {
                return '0' + s;
            }
            return s;
        }

        const orderTime = {
            day : {
                year : current.getFullYear(),
                month : padZero(current.getMonth() + 1),
                date  : padZero(current.getDate())
            },
            time : {
                hour : padZero(current.getHours()),
                minute : padZero(current.getMinutes()),
                second : padZero(current.getSeconds())
            }
        }

        const order = {
            orderTime,
            uid,
            status : '처리중',
            ...datas
        }

        const ordersRef = firebase.ref().child(`orders/`);
        const newOrderRef = ordersRef.push();
        newOrderRef.set(order)
            .then( ()=> {
                const accountOrders = firebase.ref().child(`accounts/${uid}/orders`);
                const newOrderRefInAccount = accountOrders.push();
                newOrderRefInAccount.set(newOrderRef.key)
                    .then(() => {
                        dispatch(sendOrderSuccess());
                        dispatch(clearCart());
                        if(funcs && funcs.successFunc) {
                            funcs.successFunc();
                        }
                    })
                    .catch((e) => {
                        dispatch(sendOrderFail());
                    })
            })
            .catch((e) => {
                dispatch(sendOrderFail());
            })
    }
}

export const sendOrderSuccess = ()=> {
    return {
        type : 'SEND_ORDER_SUCCESS'
    }
}
export const sendOrderFail = () =>{
    return {
        type : 'SEND_ORDER_FAIL'

    }
}

export const clearCart = ()=> {
    return (dispatch, getState, getFirebase) => {
        const { login, uid } = getState().user;
        if(login) {
            dispatch(clearCartDB(uid));
        } else {
            dispatch(clearCartLocal());
        }
    }
}
export const clearCartDB = (uid) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const userCartRef = firebase.ref().child(`cart/${uid}`);
        userCartRef.remove()
            .then(() => {
                dispatch(clearCartDBSuccess());
            })
            .catch(() => {
                dispatch(clearCartDBFail());
            })
    }
}

export const setCartDB = (uid, carts) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const userCartRef = firebase.ref().child(`cart/${uid}`);
        userCartRef.set(carts);
    }
}

export const clearCartDBSuccess = () => {
    return {
        type : 'CLEAR_CART_DB_SUCCESS'
    }
}
export const clearCartDBFail = () => {
    return {
        type : 'CLEAR_CART_DB_FAIL'
    }
}

export const clearCartLocal = () => {
    return {
        type : 'CLEAR_CART_LOCAL'
    }
}


export const updateCartQuantity = (info) => {
    return (dispatch, getState, getFirebase) => {
        const { login} = getState().user;
        if(login) {
            dispatch(updateCartQuantityDB(info));
        }
        else{
            dispatch(updateCartQuantityLocal(info));
        }
    }
}
export const updateCartQuantityDB = ({index, quantity}) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const {uid} = getState().user;

        const cartItemRef =firebase.ref().child(`cart/${uid}/${index}/`); 
        cartItemRef.update( {
            quantity
        },
            () => {
            }
        )
    }
}

export const updateCartQuantityLocal = ({index, quantity}) => {
    return {
        type : 'UPDATE_CART_QUANTITY_LOCAL',
        payload : {
            index, 
            quantity
        }
    }
}

export const clearCartInReducer = () => {
    return { type: 'CLEAR_CART_IN_REDUCER' }
}


// WEBPACK FOOTER //
// ./src/pages/Store/actions/cartActions.js